import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useSnakeBar } from '../../useSnakeBar';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';
import type {
  SearchComparisonItemsQuery,
  SearchComparisonItemsQueryResponse,
} from '../../../types/BaselineMeasurements';

import type { UseQueryWrapper } from '../../../types';

type GetComparisonItemsQueryVariables = SearchComparisonItemsQuery;
const QUERY_KEY = 'getBaselineMeasurementComparisonItems';

const queryFn = (queryVariables: GetComparisonItemsQueryVariables) => async () => {
  if (queryVariables.comparisonId) {
    const response = await baselineMeasurementService.searchComparisonItems(queryVariables);
    return (response as AxiosResponse).data;
  }
};

export const useComparisonItemsQuery: UseQueryWrapper<
  SearchComparisonItemsQueryResponse,
  GetComparisonItemsQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();
  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);
  return useQuery<SearchComparisonItemsQueryResponse>(
    [QUERY_KEY, ...Object.values(variables || {})],
    queryFn(variables),
    {
      onError,
      ...(options || {}),
    },
  );
};
